// extracted by mini-css-extract-plugin
export default {"buttonContainer":"SavedSearchAlertModalFooterButtons_buttonContainer__K0tcJ"};